module.exports = __webpack_public_path__ + "static/img/car1.c4ba555.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/car1.jpg
// module id = oI0X
// module chunks = 0